import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "../src/styles/global.scss";
import "../src/styles/common.scss";
import { Provider } from "react-redux";
import { store } from "./store/store";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
